<template lang="html">
  <div class="manual-wrapper">
    <div class="upper-wrapper">
      <RouterLink
        :to="{ name: 'Home', params: { lang: $i18n.locale } }"
        class="home-link"
      >
        <svg
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="svg-back"
        >
          <path
            d="M3.52375 6.8813L7.99375 2.14871L6.81525 0.90097L0.333418 7.76359L6.81525 14.6261L7.99375 13.3784L3.52375 8.64588H13.6667V6.8813H3.52375Z"
            fill="#E7E9EA"
          />
        </svg>
        <span>{{ $t("backToStart") }}</span></RouterLink
      >
      <div class="title">
        {{ $t("profile.purchase.newSale") }}
      </div>
      <div class="manual-title">
        {{ $t(manualInfo.manualSteps[currStep].manualTitle) }}
      </div>
      <div v-if="false" class="manual-navigation-wrapper">
        <div
          class="navigation-btn"
          @click="navigateIndex(index), checkInterval()"
          v-for="(step, index) in manualInfo.manualSteps"
          :key="index"
          :class="{ active: index <= currStep }"
        >
          {{ index + 1 }}
          <div class="navigation-btn-shedow"></div>
        </div>
        <div class="progress-bar">
          <div class="progress" :style="{ width: calcProgressWidth }"></div>
        </div>
      </div>
      <div v-else class="manual-navigation-wrapper-new">
        <div
          class="navigation-btn"
          @click="navigateIndex(index), checkInterval()"
          v-for="(step, index) in manualInfo.manualSteps"
          :key="index"
          :class="{ active: index <= currStep }"
        >
          {{ index + 1 }}
        </div>
        <div class="progress-bar">
          <div class="progress" :style="{ width: calcProgressWidthNew }"></div>
        </div>
      </div>
    </div>
    <div v-if="custom">
      <component
        :is="step.component"
        v-for="(step, index) in manualInfo.manualSteps"
        :key="index"
        v-show="index === currStep"
        :data="step.data"
        :params="params"
      ></component>
    </div>
    <transition-group name="fade" appear v-else>
      <manual-step
        v-for="(step, index) in manualInfo.manualSteps"
        :key="index"
        :data="step"
        v-show="index === currStep"
      />
    </transition-group>
    <div v-if="custom" class="actions">
      <div v-if="currStep !== 0" @click="navigateStep('back')" class="btn alt">
        {{ $t("button.button_previous_step") }}
      </div>
      <div
        v-if="currStep === manualInfo.manualSteps.length - 1"
        @click="finish"
        class="btn dark"
      >
        {{ $t("button.button_finish") }}
      </div>
      <div v-else @click="navigateStep('forward')" class="btn dark ">
        {{ $t("button.button_next_step") }}
      </div>
    </div>
    <div class="tutorial" v-else>
      <a :href="generatePreviewLink()" target="_blank">
        <div class="btn dark">
          {{ $t("main.tutorial") }}
        </div>
      </a>
      <span @click="changeReadMore()">
        {{ $t("main.readMore") }}
        <img
          :class="{ rotate: !manualInfo.manualSteps[currStep].hidden }"
          src="@/assets/icons/dropdownArrow.png"
          alt="dropdown arrow icon"
        />
      </span>
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
import ManualStep from "@/components/manual/manualStep.vue";
import BasicInfo from "@/components/newAd/basicInfo.vue";
import DetailsInfo from "@/components/newAd/detailsInfo3.vue";
import RightsInfo from "@/components/newAd/rightsInfo.vue";
import { baseURL } from "@/api";
export default {
  name: "maual",
  props: {
    manualInfo: {
      type: Object,
      required: true
    },
    custom: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      required: false
    },
    auto: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  components: {
    ManualStep,
    BasicInfo,
    DetailsInfo,
    RightsInfo
  },
  data() {
    return {
      currStep: 0,
      interval: null,
      requiredParams: [
        "pro_name",
        "pro_expiry",
        "pro_quantity",
        "mun_id",
        "pro_base_price",
        "cur_id",
        "cat_id",
        "pro_info",
        "pro_description",
        "pro_made_in",
        "prices"
      ]
    };
  },
  mounted() {
    if (this.auto) {
      this.setUpInterval();
    }
  },
  methods: {
    changeReadMore() {
      this.manualInfo.manualSteps[this.currStep].hidden = !this.manualInfo
        .manualSteps[this.currStep].hidden;
      this.setUpInterval();
    },
    generatePreviewLink() {
      return baseURL + `/documents/20/document`;
    },
    checkParams() {
      console.log(this.params);
      let res = true;
      for (var i = 0; i < this.requiredParams.length; i++) {
        if (
          !this.params.hasOwnProperty(this.requiredParams[i]) ||
          this.params[this.requiredParams[i]] === ""
        ) {
          this.$toast.error(this.$t("newAd.error." + this.requiredParams[i]), {
            duration: 8000
          });
          res = false;
          return res;
        }
        if (this.requiredParams[i] === "prices") {
          if (
            !(
              this.params[this.requiredParams[i]].length >= 2 &&
              this.params[this.requiredParams[i]].length <= 5
            )
          ) {
            this.$toast.error(this.$t("newAd.error.pricesLength"), {
              duration: 8000
            });
            res = false;
            return res;
          }
        }
      }
      // if (!this.params.hasOwnProperty('pro_declaration') && !this.params.hasOwnProperty('pro_declaration_text')) {
      //   this.$toast.error(this.$t('newAd.error.pro_declaration'), {
      //     duration: 8000
      //   })
      //   res = false
      //   return res
      // }
      if (
        parseInt(this.params.pro_quantity) >
        this.params.prices[this.params.prices.length - 1].max
      ) {
        this.$toast.error(this.$t("newAd.error.quantitySurplus"), {
          duration: 8000
        });
        res = false;
        return res;
      }
      return res;
    },
    checkInterval() {
      if (this.auto) {
        this.setUpInterval();
      }
    },
    setUpInterval() {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.navigate();
      }, 10 * 1000);
    },
    navigate() {
      if (this.currStep === this.manualInfo.manualSteps.length - 1) {
        this.currStep = 0;
      } else {
        this.currStep += 1;
      }
      for (var i = 0; i < this.manualInfo.manualSteps.length; i++) {
        this.manualInfo.manualSteps[i].hidden = true;
      }
    },
    navigateStep(dir) {
      if (dir === "forward" && this.currStep === 0 && this.custom) {
        if (!this.checkParams()) {
          return;
        }
      }
      setTimeout(function() {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
      if (dir === "back") {
        if (this.currStep !== 0) {
          this.currStep -= 1;
        }
      } else {
        if (this.currStep !== this.manualInfo.manualSteps.length - 1) {
          this.currStep += 1;
        }
      }
      for (var i = 0; i < this.manualInfo.manualSteps.length; i++) {
        this.manualInfo.manualSteps[i].hidden = true;
      }
    },
    navigateIndex(index) {
      if (this.currStep === 0 && index > 0 && this.custom) {
        if (!this.checkParams()) {
          return;
        }
      }
      this.currStep = index;
      for (var i = 0; i < this.manualInfo.manualSteps.length; i++) {
        this.manualInfo.manualSteps[i].hidden = true;
      }
    },
    finish() {
      eventBus.$emit("finish");
    }
  },
  computed: {
    calcProgressWidth() {
      return (
        Math.floor(
          (this.currStep / (this.manualInfo.manualSteps.length - 1)) * 100
        ) + "%"
      );
    },
    calcProgressWidthNew() {
      return (
        Math.floor(
          ((this.currStep + 1) / this.manualInfo.manualSteps.length) * 100
        ) + "%"
      );
    }
  },
  deleted() {
    clearInterval(this.interval);
  }
};
</script>

<style lang="scss" scoped>
.manual-wrapper {
  // padding: 30px 60px;

  .tutorial {
    text-align: left;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    color: rgba(79, 79, 79, 0.7);
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;

    a {
      text-decoration: none;
    }
    .btn {
      max-width: 150px;
      width: auto;
    }

    span {
      margin-left: 20px;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        margin-left: 5px;
        margin-top: 2px;
        transition-duration: 0.3s;
      }
      img.rotate {
        transform: rotate(180deg);
      }
    }
  }
  .upper-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: baseline;
    height: auto;
    flex-wrap: wrap;

    .home-link {
      font-weight: 500;
      font-style: Medium;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0%;
      color: $gray-blue-700;
      text-decoration: none;

      margin-bottom: 36px;
      span {
        margin-left: 7px;
      }
    }
    .home-link:hover {
      color: $blue-400;
      .svg-back > path {
        fill: $blue-400 !important;
      }
    }
    .title {
      font-weight: 600;
      font-style: SemiBold;
      font-size: 36px;
      line-height: 100%;
      letter-spacing: 0%;
      color: $blue-1000;
      margin-bottom: 22px;
    }

    .manual-title {
      font-weight: 400;
      font-style: Regular;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0%;
      color: $blue-400;
      margin-bottom: 80px;
    }
    // setp old
    .manual-navigation-wrapper {
      min-width: 180px;
      margin-bottom: 60px;
      flex-grow: 1;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      position: relative;

      .navigation-btn {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background: $gray-blue-1300;
        color: $gray-blue-100;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition-duration: 0.3s;
        font-weight: bold;
        line-height: 26px;
        letter-spacing: 0.06em;
        font-size: 13px;
        z-index: 1;
        position: relative;

        .navigation-btn-shedow {
          box-shadow: none;
          transition-duration: 0.3s;
          height: 100%;
          width: 100%;
          position: absolute;
          border-radius: 50%;
        }
      }
      .navigation-btn.active {
        height: 32px;
        width: 32px;
        transition-delay: 0.3s;
        background: linear-gradient(
          180deg,
          $light-blue-400 5.95%,
          $light-blue-700 220.31%
        );
        color: white;
        font-size: 15px;
        box-shadow: 0 0 0 5px $light-blue-300;

        .navigation-btn-shedow {
          display: block;
          // box-shadow: 0px 3px 14px rgba(81, 15, 51, 0.6);
        }
      }
      .progress-bar {
        position: absolute;
        width: 100%;
        height: 5px;
        background-color: $gray-blue-1300;

        .progress {
          height: 5px;
          background-color: $light-blue-400;
          transition-duration: 0.7s;
        }
      }
    }
    // step new
    .manual-navigation-wrapper-new {
      min-width: 217px;
      margin-bottom: 60px;
      flex-grow: 1;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      position: relative;

      .navigation-btn {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background: $gray-blue-1300;
        color: $gray-blue-100;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition-duration: 0.3s;
        font-weight: bold;
        line-height: 26px;
        letter-spacing: 0.06em;
        font-size: 13px;
        z-index: 1;
        position: relative;
      }
      .navigation-btn.active {
        background: $light-blue-600;
      }
      .progress-bar {
        position: absolute;
        width: 100%;
        height: 3px;
        background-color: $gray-blue-1300;
        bottom: -15px;

        .progress {
          height: 3px;
          background-color: $light-blue-600;
          transition-duration: 0.7s;
        }
      }
    }

    // end new step
  }
  .actions {
    display: flex;
    flex-direction: row;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    @import "@/assets/scss/btnStyles.scss";
    margin-top: 30px;

    .btn {
      margin-left: 20px;
      border-radius: 10px;
      // padding-top: 12px;
      // display: inline-block;
    }
    .btn::first-letter {
      text-transform: uppercase !important;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.7s;
}
.fade-leave-active {
  display: none;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter {
  // margin-left: -20px;
}

@media only screen and (max-width: 768px) {
  .manual-title {
    min-width: 0px !important;
    flex-grow: 1;
    margin-right: 15px;
  }
  .manual-navigation-wrapper {
    min-width: 130px !important;
  }
}
@media only screen and (max-width: 550px) {
  .manual-wrapper {
    .upper-wrapper {
      display: flex;
      flex-direction: column !important;
      justify-content: space-between;
      align-items: baseline;
      height: auto;
      flex-wrap: wrap;

      .manual-navigation-wrapper {
        min-width: initial;
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
